import { PRODUCT_TYPE_IDS } from "./constants";

const NO_SHIPPING_FEE = 0;

const calculateLocalCartProductsCost = (items) =>
  items.reduce((currentTotalCost, item) => currentTotalCost + item.product.sellingPrice * item.quantity, 0);

const calculateLocalCartShippingFee = (items, minBottlesForFreeShipping, standardShippingFee) => {
  const oneOffWines = items.filter(
    (item) => item.product.productType.id === PRODUCT_TYPE_IDS.DB_ID_PRODUCT_TYPE_WINE
  );
  if (!oneOffWines.length) return NO_SHIPPING_FEE;

  const numberOfBottles = oneOffWines.reduce((total, item) => total + item.quantity, 0);
  return numberOfBottles < minBottlesForFreeShipping ? standardShippingFee : NO_SHIPPING_FEE;
};

export { calculateLocalCartProductsCost, calculateLocalCartShippingFee };
